/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Planner_CookInputs */

const en_planner_cook = /** @type {(inputs: Planner_CookInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cook: ${i?.title}`)
};

const de_planner_cook = /** @type {(inputs: Planner_CookInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kochen: ${i?.title}`)
};

/**
* | output |
* | --- |
* | "Cook: {title}" |
*
* @param {Planner_CookInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const planner_cook = /** @type {((inputs: Planner_CookInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planner_CookInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_planner_cook(inputs)
	return en_planner_cook(inputs)
});